import { alias, deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number;
	amount?: number;
	stage?: string;
	name?: string;
	assignedBudgetId?: number | null;
	assignedBudgetName?: string | null;
}

export class Opportunity {
	public static fromJson(json: IJsonObject): Opportunity {
		return deserialize(Opportunity, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Opportunity[] {
		return json.map((user: IJsonObject) => this.fromJson(user));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public amount: number;

	@serializable(alias("stagename"))
	public stage: string;

	@serializable
	public name: string;

	// Only sent when listed for a budget's picker: the other budget this
	// opportunity already pays towards, if any.
	@serializable(alias("assigned_budget_id"))
	public assignedBudgetId: number | null;

	@serializable(alias("assigned_budget_name"))
	public assignedBudgetName: string | null;

	constructor({
		id = 0,
		amount = 0,
		stage = "",
		name = "",
		assignedBudgetId = null,
		assignedBudgetName = null,
	}: IProps = {}) {
		this.id = id;
		this.amount = amount;
		this.stage = stage;
		this.name = name;
		this.assignedBudgetId = assignedBudgetId;
		this.assignedBudgetName = assignedBudgetName;
	}
}
